<template>
	<div class="funnel-container">
		<slot></slot>
	</div>
</template>

<script>
import { FUNNELS, FUNNEL_PATH_PREFIXES } from '@/data/funnels'
import { mapGetters } from 'vuex'

export default {
	name: 'FunnelContainer',

	watch: {
		activeFunnelType: {
			handler(funnelType, oldFunnelType) {
				if (funnelType.id === oldFunnelType?.id) {
					return
				}
				this.storeFunnel(funnelType)
			},
			immediate: true
		}
	},

	computed: {
		...mapGetters({
			domain: 'location/domain',
			funnelType: 'location/getFunnelType',
			getQueryParam: 'location/getQueryParam',
			property: 'survey/getPropertyValue',
			language: 'i18n/getLanguage',
			countryCode: 'getCountryCode'
		}),

		activeFunnelType() {
			let funnelType = FUNNELS.MAIN

			if (!(this.$route.meta.isLanding && this.$route.query.utm_source)) {
				funnelType = this.funnelType
			}

			const queryFunnelKey = this.getQueryParam('funnelType')
			if (queryFunnelKey && FUNNELS[queryFunnelKey?.toUpperCase()]) {
				return FUNNELS[queryFunnelKey?.toUpperCase()]
			}

			if (this.IS_FEMALE_FUNNEL_EMAIL_BEFORE_PREDICT_EXP) {
				return FUNNELS.FEMALE_EMAIL_BEFORE_PREDICT
			}

			if (this.IS_OPTIMIZED_FEMALE_FUNNEL_EXP) {
				return FUNNELS.FEMALE_OPTIMIZED
			}

			if (!this.domain.SIMPLEAPP && this.$route.fullPath.startsWith(FUNNEL_PATH_PREFIXES.male)) {
				funnelType = this.countryCode === 'us' ? FUNNELS.MALE_EMAIL_BEFORE_PREDICT : FUNNELS.MALE
			} else if (
				this.domain.ACTIVITY ||
				(!this.domain.SIMPLEAPP && this.$route.fullPath.startsWith(FUNNEL_PATH_PREFIXES.activity))
			) {
				if (this.$route.fullPath.startsWith(FUNNEL_PATH_PREFIXES.female) || this.IS_FEMALE_ACTIVITY_FUNNEL) {
					funnelType = FUNNELS.FEMALE_ACTIVITY_FUNNEL
				} else {
					funnelType = FUNNELS.MALE_ACTIVITY_FUNNEL
				}
			} else if (!this.domain.SIMPLEAPP && this.$route.fullPath.startsWith(FUNNEL_PATH_PREFIXES.female)) {
				funnelType = FUNNELS.FEMALE
			} else if (this.domain.YOUTUBE) {
				funnelType = FUNNELS.YOUTUBE
			} else if (this.domain.SIMPLEAPP) {
				if (this.$route.fullPath.startsWith(FUNNEL_PATH_PREFIXES.activity) || this.IS_NOFASTING_ACTIVITY_MALE) {
					funnelType = FUNNELS.NOFASTING_ACTIVITY_MALE
				} else if (this.$route.fullPath.startsWith(FUNNEL_PATH_PREFIXES.female) || this.IS_FEMALE_FUNNEL) {
					funnelType = FUNNELS.NOFASTING_FEMALE
				} else if (this.$route.fullPath.startsWith(FUNNEL_PATH_PREFIXES.male) || this.IS_MALE_FUNNEL) {
					funnelType = FUNNELS.NOFASTING_MALE
				} else {
					funnelType = FUNNELS.NOFASTING
				}
			} else if (this.IS_MAIN_FUNNEL) {
				funnelType = this.countryCode === 'us' ? FUNNELS.MAIN : FUNNELS.MAIN_NON_US
			}
			return funnelType
		}
	},

	methods: {
		storeFunnel(funnelType) {
			this.$store.commit('location/setFunnelType', {
				funnelType
			})
			this.$analytic.updatePersistedProperties({ funnel_type: funnelType.slug, funnel_id: funnelType.id })
			this.$analytic.setUserProperties({
				FunnelId: funnelType.id
			})

			const maybeSex = funnelType.sex ?? funnelType.slug
			if (['male', 'female'].includes(maybeSex)) {
				this.$analytic.setUserProperties({
					Sex: maybeSex
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.funnel-container {
	min-height: calc(var(--vh, 1vh) * 100);
}
</style>
